import { SearchBox } from "@fluentui/react/lib/SearchBox";

import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { DatePickerDialog } from "./DatePickerDialog";
import { useAutoCompleteStyles } from "./UseAutoCompleteStyles";
import { SuggestionList } from "./SuggestionList";
import { IWithSearchContextProps, WithSearchContext } from "../SearchContext";
import { useAutoComplete } from "./UseAutoComplete";

export const AutoComplete = WithSearchContext(
  WithTranslator((props: IWithSearchContextProps & IWithTranslatorProps): JSX.Element => {
    const {
      translator, onAdd, searchRef, searchTerm
    } = props;
    const styles = useAutoCompleteStyles();

    const {
      onChange, onFocusDiv, onFocusSearchBox, onKeyDown, searchBoxRef
    } = useAutoComplete();

    return (
      <div onFocus={onFocusDiv}>
        <div ref={searchRef}>
          <SearchBox
            componentRef={searchBoxRef}
            className={styles.root}
            autoComplete="off"
            iconProps={{ iconName: `Filter` }}
            onChange={onChange}
            onSearch={onAdd}
            placeholder={`${translator.get(`search.filter`, `Filter projects`)}...`}
            underlined
            onFocus={onFocusSearchBox}
            onKeyDown={onKeyDown}
            value={searchTerm}
          />
        </div>
        <SuggestionList />
        <DatePickerDialog />
      </div>
    );
  })
);
